import type {QuoteFont} from '../resolver/types';

// Labels are hardcoded English like the rest of the designer's option surfaces — a known
// limitation of the stopgap, resolved when the final designer ships.
export const FONT_OPTIONS: Array<{value: QuoteFont; label: string}> = [
	{value: 'helvetica', label: 'Helvetica'},
	{value: 'times', label: 'Times (serif)'},
	{value: 'courier', label: 'Courier (mono)'},
];

// Helvetica, Times and Courier are built-in to @react-pdf — no font registration needed.
// Additional faces would require bundling their .ttf binaries.
export function registerQuoteFonts(): void {
	// no-op for the current font set
}

export function fontFamily(font: QuoteFont): string {
	switch (font) {
		case 'times':
			return 'Times-Roman';
		case 'courier':
			return 'Courier';
		default:
			return 'Helvetica';
	}
}
